import UserGroupDto from 'common/dto-types/user-group-dto';

export type ImageDto = {
    src: string;
    altText?: string;
    width?: number;
    height?: number;
};

export type ArticlePreviewDto = {
    articleId: string;
    articleTitle: string;
    articleLink: string;
    articleImage: ImageDto;
    userGroups: UserGroupDto[];
};

export enum MessageArticleValidationStatus {
    Idle = 'idle',
    Validating = 'validating',
    Success = 'success',
    Error = 'error',
}

export type ValidationStatus = MessageArticleValidationStatus;

export type ContentfulArticleSearchFieldProps = {
    name: string;
    label: string;
    value: string;
    onChange: (value: string) => void;
    onBlur?: (e: any) => void;
    onValidationStatusChange?: (status: ValidationStatus) => void;
    onArticlePreviewChange?: (preview: ArticlePreviewDto | null) => void;
    error?: boolean;
    helperText?: string;
    disabled?: boolean;
    isRequired?: boolean;
};
